import React, { useEffect, useRef, useState } from "react"
import style from "../../../style/UpdateStock.module.css"
import { GetSmallModels } from "../../../Models/GetModels/GetModels.js"
import {
    faBarcode, faCalculator, faCamera, faCircleInfo, faKeyboard, faListUl, faLock, faMagnifyingGlass,
    faSave, faScaleBalanced, faSliders, faTrashCan
} from "@fortawesome/free-solid-svg-icons"
import { faNewspaper } from "@fortawesome/free-regular-svg-icons"
import InputModels from "../../../Models/InputModels/InputModels.js"
import { getMapFromList, setUpdateBatch } from "../../../controllers/CloudItems.js"
import  { TitlePageResponsiveIcon } from "../../../layout/TitlePage/TitlePage.js"
import { ToggleButtonWithContainer } from "../../../layout/ToggleButton/ToggleButton.js"
import FindWithBarcode from "../../FindWithBarcode/FindWithBarcode.js"
import GetFloatingButton, { GetFloatingButtonWithLegend } from "../../../layout/GetFloatingButton/GetFloatingButton.js"
import Loader from "../../../layout/Loader/Loader.js"
import InputModelsBlock from "../../../Models/InputModelsBlock/InputModelsBlock.js"
import ItemsSale from "../../../objects/ItemBJ/ItemsSale.js"
import GetExpandedImage from "../../../layout/GetExpandedImage/GetExpandedImage.js"
import ItemModelList from "../../../Models/ItemModelList/ItemModelList.js"
import CalculateBj from "../../../objects/CalculateBj.js"
import ConfirmationPopup from "../../../Models/ConfirmationPopup/ConfirmationPopup.js"
import Alert from "../../../Models/Alert/Alert.js"
import { useError, useLoading } from "../../../AppContext.js"
import { findBjItems, initSystem, listItemsMemory, myStoreDataMemory } from "../../../backEnd/Memory.js"
import { employeeData } from "../../../backEnd/InitController.js"
import { requestPDFs, setNewPdfSaveReposition } from "../../../controllers/CloudPdfs.js"
import { useNavigate } from "react-router-dom"
import { routerFromStockBj } from "../../../routers/routerList.js"
import { getMotion, setNewReposition } from "../../../controllers/CloudRepositions.js"
import Barcode from "../../Barcode/Barcode.js"
import Space from "../../../layout/Space.js"
import { GetButton } from "../../../layout/ButtonsLayout/ButtonsLayout"
import { delay } from "lodash"

export const labelListReposition = "repositionSaveData"
export const labelToggleStatus = "toggleStatus"
const calculateBj = new CalculateBj()

function InitDataMemory(listItem) {

    const dataLocal = localStorage.getItem(labelListReposition);
    if (dataLocal) {
        const parsedData = JSON.parse(dataLocal)
        var list = parsedData.map(itemDataLocal => {
            const foundItem = listItem.find(element => element.itemGlobal.codebar === itemDataLocal.itemGlobal.codebar)
            if (foundItem) {
                const item = new ItemsSale()
                item.fromCloud(itemDataLocal, foundItem.itemGlobal);
                return item
            }
            return null
        }).filter(item => item !== null)

        calculateBj.calculate(list)
        return list
    }
    return []
}

export const clearAndInsert = (list,isNormal) =>{
    localStorage.removeItem(labelListReposition)
    localStorage.removeItem(labelToggleStatus)
    localStorage.setItem(labelToggleStatus,isNormal)
    calculateBj.clear()
    localStorage.setItem(labelListReposition, JSON.stringify(list))
}



function UpdateStock() {
    const navigate = useNavigate()

    const [canEdite] = useState(employeeData().employeePermission.permissionsItems[0])
    const [toggleStatus, setToggleStatus] = useState(() => {
        const storedValue = localStorage.getItem(labelToggleStatus)
        return storedValue ? storedValue === 'true' : true
    })

    const { setIsLoading } = useLoading()
    const containerRef = useRef(null)
    const [limit, setLimit] = useState([50])

    const [showReadbarCode,setShowReadbarCode] = useState(false)
    const [showAlertSave, setShowAlertSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)

    const [listItems, setListItems] = useState(listItemsMemory)
    const [filtered, setFiltered] = useState([])
    const [list, setList] = useState(listItemsMemory)

    const [loading, setLoading] = useState(false)

    const { showError } = useError()

    const [isExpanded, setIsExpanded] = useState(false)
    const [nameProduct, setNameProduct] = useState('')
    const [linkImage, setSetLinkImage] = useState('')

    const [inputBarcode, setInputbarcode] = useState('')

    const [statusFindWithCode, setStatusFindWithCode] = useState(false)

    const onValidator = (item, amount) => {
        var itemTemp = []
        var temp = []

        if (toggleStatus) {
            const foundIndex = list.findIndex(element => element.itemGlobal.codebar === item.itemGlobal.codebar)
            temp = []
            if (foundIndex !== -1) {
                temp = [...list]
                temp[foundIndex].amount += amount
            } else {
                itemTemp = { ...item }
                itemTemp.amount = amount
                temp = [...list, itemTemp]
            }
            saveLocalStorage(temp)
            return true
        } else {
            temp = []
            const foundIndex = listItems.findIndex(element => (element.itemGlobal.codebar === item.itemGlobal.codebar))

            if (foundIndex !== -1) {
                const hasIndex = list.findIndex(element => (element.itemGlobal.codebar === item.itemGlobal.codebar))

                if (hasIndex !== -1) {
                    if (list[hasIndex].amount + amount <= listItems[foundIndex].amount) {
                        temp = [...list]
                        temp[hasIndex].amount += amount
                    } else {
                        serErrorAmount()
                        return false
                    }

                } else {
                    itemTemp = { ...item }
                    itemTemp.amount = amount

                    if (itemTemp.amount <= listItems[foundIndex].amount) {
                        temp = [...list, itemTemp]
                    }
                    else {
                        serErrorAmount()
                        return false
                    }
                }
            }

            saveLocalStorage(temp)
            return true
        }
    }

    const serErrorAmount = () => {
        showError("A Quantidade ésta Inferior a Zero", "Não é Permitido Remover Peças Sem Estoque...")
    }

    const saveLocalStorage = (temp) => {
        localStorage.setItem(labelListReposition, JSON.stringify(temp))
        resetList(listItems)
    }

    const resetList = (results) => {
        var dataFromStorage = InitDataMemory(results)
        setList(dataFromStorage)
        setFiltered(dataFromStorage)
    }

    const toggleImageExpansion = (nameProduct, linkImage) => {
        setIsExpanded(!isExpanded)
        setNameProduct(nameProduct)
        setSetLinkImage(linkImage)
    }

    useEffect(() => {
        if (canEdite) {
            (async () => {
                setTimeout(async () => {
                    await handleFindDataBase();
                }, 100); 
            })();
        }
    }, []);
    
    const handleFindDataBase = async () => {
        setLoading(true)
        setIsLoading(true)
        await initSystem(showError)
        setListItems(listItemsMemory)
        resetList(listItemsMemory)
        setLoading(false)
        setIsLoading(false)
    }

    const handleChangeFilter = (value) => {
        const data = [...list]
        resetScroll()
        if (value != null) {
            const filteredStock = data.filter(
                stock => {
                    const filternName = stock.itemGlobal.name.toLowerCase().includes(value.target.value.toLowerCase())
                    return filternName
                }
            )
            setFiltered(filteredStock)
        } else {
            setFiltered(data)
        }
    }

    const resetScroll = () => {
        const container = containerRef.current
        container.scrollTop = 0
        setLimit(50)
    }

    const checkScroll = () => {
        const container = containerRef.current;
        const scrollPosition = container.scrollTop;
        const containerHeight = container.clientHeight;
        const scrollHeight = container.scrollHeight;

        if (scrollPosition + containerHeight >= scrollHeight) {
            setLimit((limit + 50))
        }
    }

    const handleToggleChange = (newToggleStatus) => {
        localStorage.setItem(labelToggleStatus, newToggleStatus)
        setToggleStatus(newToggleStatus)
        handleClear()
    }

    const handleClear = () => {
        localStorage.removeItem(labelListReposition)
        localStorage.removeItem(labelToggleStatus)
        resetList(listItems)
        calculateBj.clear()
    }

    const handleCloseFindWithCode = () => {
        setStatusFindWithCode(false)
    }

    const handleOpenFindWithCode = () => {
        setStatusFindWithCode(true)
    }

    const onRemove = (itemToRemove) => {
        const temp = list.filter(item => item !== itemToRemove)
        saveLocalStorage(temp)
    }

    const onLess = (data) => {
        data.amount--
        if (data.amount <= 0)
            onRemove(data)
        else saveLocalStorage(list)

    }

    const handleTrySave = () => {
        if (list.length <= 0) {
            showError("A Lista Temporária Está Vazia", "Não é Permitido Atualizar uma Lista Vazia...")
            return
        }

        setShowConfirmSave(true)
    }

    const handleSave = async () => {
        setShowConfirmSave(false)
        setLoading(true)
        setIsLoading(true)
        var results = await setUpdateBatch(list, toggleStatus, showError)
        setNewReposition(getMotion(toggleStatus),false,list,showError)

        if (results.status === 200) {
            await findBjItems()
            const blob = await requestPDFs({
                'type':'pdfRepositionBJ',
                'employee': employeeData().genericPerson.name,
                'typeOperation': toggleStatus? 1:0,
                'total':calculateBj.items,
                'models':calculateBj.models,
                'grams':calculateBj.grams,
                'date':new Date().toISOString().replace("T",' ').slice(0,19),
                'listItems': getMapFromList(list,''),
                'myStore': myStoreDataMemory.getMapFromCloud()
            },showError)
            setNewPdfSaveReposition(blob)
            navigate(routerFromStockBj)
            setShowAlertSave(true)
            handleToggleChange(true)
            handleClear()
        }

        setLoading(false)
        setIsLoading(false)
    }

    const handleReadbarcode = (e) => {
        setInputbarcode(e.target.value)
        if (e.target.value.length >= 13) {
            var indexItem = listItems.findIndex(element => element.itemGlobal.codebar === e.target.value)
            if (indexItem !== -1) {
                onValidator(listItems[indexItem], 1)
            } else {
                showError("Código de Barras Inválido", "Não Há Peças com Esse Código de Barras")
                e.target.blur()
            }
            setInputbarcode('')
        }
    }

    const handlerCameraBarcode = (valueBarcode) =>{
        var indexItem = listItemsMemory.findIndex(element => element.itemGlobal.codebar.toString() === valueBarcode)
        if (indexItem !== -1) {
            if(onValidator(listItemsMemory[indexItem], 1)){
                return listItemsMemory[indexItem]
            }
        } else {
            showError("CÓDIGO DE BARRAS INVÁLIDO", "Não Há Peças com Esse Código de Barras")
            setShowReadbarCode(false)
            return null
        }

        return null
    } 


    let label = toggleStatus ? 'Reposição' : 'Remoção'
    let label2 = toggleStatus ? 'Repor' : 'Remover'

    return (
        <div>
            {!canEdite ?
                <div className={style.containerGlobal}>
                    <div className={style.div}>
                        <GetSmallModels icon={faLock} title={'ACESSO NEGADO'}
                            subtitle={'Você Não Tem Permissão para Editar o Estoque da Loja'} />
                    </div>
                </div>
                :
                <>
                    <div className={style.containerGlobal}>
                        <div className={style.containerCenter}>
                            {!loading ?
                                <>
                                    <div className={style.divList}>
                                        <div className={style.row}>
                                            <TitlePageResponsiveIcon subtitle={'Lista Temporária de Reposição!'}
                                                path={'É a Lista das Peças que Você Deseja ' + label2 + ' do Estoque'} icon={faListUl} />
                                            <div className={style.containerToggleType}>
                                                <ToggleButtonWithContainer
                                                    titleOn={'REPOR PEÇAS'} titleOff={'REMOVER PEÇAS'}
                                                    initState={toggleStatus} onInput={(e)=>handleToggleChange(e)} />
                                            </div>
                                        </div>
                                        <div className={style.buildList}>
                                            <div className={style.build} ref={containerRef} onScroll={checkScroll}>
                                                {(filtered.length === 0) ?
                                                    <GetSmallModels title={"Não há Produtos com Esse Filtro"}
                                                        subtitle={"Tente Trocar o Filtro..."} icon={faCircleInfo} /> :
                                                    filtered.slice(0, limit).map((data, index) => (
                                                        <div key={index}>
                                                            <ItemModelList
                                                                onPlus={() => onValidator(data, 1)}
                                                                onLess={() => onLess(data)}
                                                                onRemove={() => onRemove(data)} data={data} fucntionButton={() => { }} functionImage={
                                                                    () => toggleImageExpansion(data.itemGlobal.name, data.getImage())} />
                                                        </div>
                                                    ))}
                                            </div>
                                            <div className={style.inputFilter}>
                                                <InputModels iconButton={faMagnifyingGlass} type={"number"}
                                                    placeholder={"Buscar Peças na Lista Acima..."} maxLength={25}
                                                    onChange={handleChangeFilter} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={style.data}>
                                        <div className={style.div}>
                                            <TitlePageResponsiveIcon subtitle={'Peças na Lista de ' + label}
                                                path={'É uma Breve Contabilidade da ' + label} icon={faCalculator} />
                                            <div className={style.div}>
                                                <GetSmallModels title={'Modelos na Lista de ' + label} value={calculateBj.models + ' Modelos'}
                                                    subtitle={'É a Somatória dos Modelos de Peças na Lista de ' + label} icon={faNewspaper} />
                                                <GetSmallModels title={'Peças na Lista de ' + label} value={calculateBj.items + ' Un'}
                                                    subtitle={'É a Somatória de Todas as Peças da Lista de ' + label} icon={faSliders} />
                                                <GetSmallModels title={'Gramas na ' + label} value={calculateBj.grams.toFixed(2) + 'g'}
                                                    subtitle={'É a Somatória Total das Gramas na Lista de ' + label} icon={faScaleBalanced} />
                                            </div>
                                        </div>
                                        <div className={style.div}>
                                            <div className={style.inputInserItems}>
                                                <InputModelsBlock legend={'INSIRA O CÓDIGO DE BARRAS'} iconButton={faBarcode} type={"number"}
                                                    value={inputBarcode}
                                                    placeholder={"Código de Barras..."} maxLength={13}
                                                    onChange={handleReadbarcode} />
                                                    <Space top={5}/>
                                                    {window.innerWidth<1200? <GetButton title={'LER CÓDIGO DE BARRAS'} handleFunction={()=>setShowReadbarCode(true)} icon={faCamera} color={"#ff0000"}/>:null}
                                            </div>
                                        </div>
                                    </div>
                                </> : <Loader titleFinding={'Estabelecendo Comunicação com o Servidor'}
                                    subtitleFinding={'Aguarde...'} loading={loading} />
                            }
                        </div>
                    </div>
                    {showAlertSave ? <Alert top={100} message={"Estoque Atualizado com Sucesso"} onClose={() => setShowAlertSave(false)} type={"success"} /> : null}
                    {showConfirmSave ? <ConfirmationPopup title={'ATUALIZAR ESTOQUE EM LOTE'} message={'Tem Certeza que Deseja Atualizar o Estoque em Lote'} onCancel={() => setShowConfirmSave(false)} onConfirm={handleSave} /> : null}
                    {isExpanded ? <GetExpandedImage nameProduct={nameProduct} linkImage={linkImage} onClose={toggleImageExpansion} /> : null}
                    {
                        !loading ? <>
                            {
                            window.innerWidth <= 1200 ?
                                <>
                                    <GetFloatingButton width={65} height={65} icon={faKeyboard} color='#007bff' margiBottom={145} handleFunction={handleOpenFindWithCode} margiRight={'1%'}/>
                                    <GetFloatingButton width={65} height={65} icon={faTrashCan} handleFunction={handleClear} color='#ff0000' margiBottom={75} margiRight={'1%'}/>
                                    <GetFloatingButton width={65} height={65} icon={faSave} handleFunction={handleTrySave} color='#007bff' margiRight={'1%'} margiBottom={'1%'} />
                                </>:
                                <>
                                    <GetFloatingButtonWithLegend legend={'BUSCAR POR Código'} width={window.innerWidth <= 1200? '40%' :275} icon={faKeyboard} color='#007bff' margiRight={225} handleFunction={handleOpenFindWithCode} />
                                    <GetFloatingButton icon={faTrashCan} handleFunction={handleClear} color='#ff0000' margiRight={120} />
                                    <GetFloatingButton icon={faSave} handleFunction={handleTrySave} color='#007bff' margiRight={20} />
                                </>
                            }   
                        </> : null
                    }
                    {showReadbarCode ? <Barcode onClose={()=>setShowReadbarCode(false)} onValidate={handlerCameraBarcode}/>: null}
                    {statusFindWithCode ? <FindWithBarcode isBJ={true} onValidator={onValidator} list={[...listItems]} onClose={handleCloseFindWithCode} /> : null}
                </>}
        </div>
    )
}

export default UpdateStock